import axios from "axios";
import * as Sentry from "@sentry/browser";
import Intercom from "src/composables/Intercom";
import Analytics from "src/composables/Analytics";

const {call_intercom} = Intercom()
const {log_event} = Analytics();

export default () => {
  const process_contact_center_link = function ({customer_name, cp_link_id}) {
    let attempts = 0
    const max_attempts = 20
    const intercom_interval = setInterval(async () => {
      attempts++;
      if (window.Intercom) {
        const visitor_id = window.Intercom('getVisitorId');

        if (visitor_id) {
          clearInterval(intercom_interval);
          // Warning: Update method is throttled to 20 calls per 30 minutes per visitor.
          //   Documentation: https://developers.intercom.com/installing-intercom/web/methods/#intercomupdate
          //   The current quota is only 20 calls per 30 minutes.
          // Note: If a user first initiates a conversation with CP via the chat widget, they will appear in the
          //   Intercom UI with a User ID property equal to their visitor ID. However, the API will not find/return
          //   the user when you make a call to search users using the external_id property.  If you call the update
          //   method with the user_id property first, the API will find and return user even though no visible update
          //   will be made to the user in Intercom.  Logic.
          let contact_center_api_url = `${ process.env.VUE_APP_CONTACT_CENTER_URL }/api/intercom/contacts/${ visitor_id }`;

          try {
            let {data} = await axios.get(contact_center_api_url,
              {
                headers: {}
              });

            if (data?.id) {
              if (!data.name && customer_name) {
                // Intercom does not have a name set, but a name was supplied via order link. Update Intercom contact with name.
                let contact_center_api_update_url = `${ process.env.VUE_APP_CONTACT_CENTER_URL }/api/intercom/contacts/${ data.id }`;

                await axios.patch(contact_center_api_update_url,
                  {name: customer_name},
                  {responseType: 'json'})
              }
            }
            else {
              // Must run update method first in order for the visitor id to be found via API
              call_intercom({command: 'update', props: {user_id: visitor_id}})
            }
            if (cp_link_id) {
              let contact_center_api_click_url = `${ process.env.VUE_APP_CONTACT_CENTER_URL }/api/calls/order_links/${ cp_link_id }/process_click`;
              await axios.patch(contact_center_api_click_url,
                {user_id: visitor_id},
                {responseType: 'json'}
              );
            }

            log_event({
              name: 'order_link_clicked',
              cp_link_id,
              visitor_id
            })
          }
          catch (err) {
            Sentry.captureException(err)
          }
        }
      }
      else if (attempts >= max_attempts) {
        clearInterval(intercom_interval);
      }
    }, 500)
  }

  return {
    process_contact_center_link
  }
}
